export class DeliveryAreaCityModel {
    constructor(payload) {
        const { uuid, baseGlobalId, name, areaRegion, areaFee, id } = payload;
        this.uuid = uuid;
        this.baseGlobalId = baseGlobalId;
        this.name = name;
        this.areaRegion = areaRegion;
        this.areaFee = areaFee;
        this.id = id;
    }
    get regionName() {
        return this.areaRegion.name;
    }
    get deliveryFee() {
        return this.areaFee.price;
    }
    get formattedCityName() {
        const lastIndex = this.name.lastIndexOf(' ');
        return this.name.substring(0, lastIndex);
    }
}
